/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type AnalyticsDescribeSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type AnalyticsDescribeRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type AnalyticsDescribeSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const AnalyticsDescribeSecurity$outboundSchema: z.ZodMiniType<
  AnalyticsDescribeSecurity$Outbound,
  AnalyticsDescribeSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function analyticsDescribeSecurityToJSON(
  analyticsDescribeSecurity: AnalyticsDescribeSecurity,
): string {
  return JSON.stringify(
    AnalyticsDescribeSecurity$outboundSchema.parse(analyticsDescribeSecurity),
  );
}

/** @internal */
export type AnalyticsDescribeRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const AnalyticsDescribeRequest$outboundSchema: z.ZodMiniType<
  AnalyticsDescribeRequest$Outbound,
  AnalyticsDescribeRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function analyticsDescribeRequestToJSON(
  analyticsDescribeRequest: AnalyticsDescribeRequest,
): string {
  return JSON.stringify(
    AnalyticsDescribeRequest$outboundSchema.parse(analyticsDescribeRequest),
  );
}
